export default String.raw`
<div class="message-popup-background container-to-delete-js">
	<div class="change-data-container">
		<div class="data-form">
			<div class="data-form__header">
			{{ translations.NewAddress }}
				<button class="close-button cancel-js" aria-label="{{ translations.Close }}">
					<svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
				</button>
			</div>
			<div class="form-js form-into-data-js">
				<div class="toggle-button">
					<input id="cbx" type="checkbox" name="default">
					<label role="switch" tabindex="0" aria-checked="false" class="toggle" for="cbx"><span></span></label>
					<span class="text">{{ translations.SetAsDefault }}</span>
				</div>
				{% capture inc -%}add-da={{config.Countries[0].ISOCode}}{% endcapture -%}
				<div class="add-da-js">
					{% include 'partials/common/address-form.html' with inc -%}
				</div>
				<div class="required-fields"><span class='required'>*</span> {{ translations.RequiredFields }}</div>
				<input type="hidden" name="__action" value="Customer/DeliveryAddressAdd" >
				<button class="primary-action-button add-new-address-in-profile-js" data-container=".delivery-addresses-container-js" data-template="partials/customer-profile/customer-details/deliv-addresses.html">
					{{ translations.Add }}
				</button>
			</div>
		</div>
	</div>
</div>
`